// TODO: disclaimer message before redirecting to overcast
import QRCode from 'qrcode';
import React, { useEffect, useState, useRef } from 'react';
import { isMobile } from 'react-device-detect';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import '../index.scss';
import IosInstructions from './IosInstructions';
import mixpanel from 'mixpanel-browser';
import { observer } from 'mobx-react';
import userStore from '../../../Stores/User';
import spotify from "../../../Assets/podcast-apps/Spotify_icon.svg";

const FRONTEND_ENDPOINT = process.env.REACT_APP_FRONTEND_URL;
// const FRONTEND_ENDPOINT = "http://192.168.1.66:3000";

const Ios = observer((props) => {

// function Ios(props) {
  const [qrCode, setQrCode] = useState();
  const [app, setApp] = useState('');
  const [showInstructions, setShowInstructions] = useState(false);
  const articleUrl = queryString.parse(props.location.search).article_url;
  const isOnboarding = queryString.parse(props.location.search).is_onboarding;
  const feedUrl = queryString.parse(props.location.search).feed_url;
  const applePodcastsRef = useRef(null);
  const overcastRef = useRef(null);
  const pocketCastsRef = useRef(null);
  const googlePodcastsRef = useRef(null);
  const castroRef = useRef(null);
  const radioPublicRef = useRef(null);
  const downcastRef = useRef(null);
  
  let {userFeedUrl} = userStore;
  // const feedUrl =
  //   "https://audiblogs-conversions-new.s3.us-east-1.amazonaws.com/samples/e7cad2dc-e8ac-4489-9b3c-102f600b4c45.xml";

  useEffect(() => {
    mixpanel.track(
      `Open iOS Page on ${isMobile ? 'Mobile' : 'Desktop'} (Onboarding)`
    );
    
    if (!userFeedUrl){
      userFeedUrl = feedUrl;
    }
    
    if (userFeedUrl){

      try{
        // add event listner on click of the link id=apple-podcasts
        applePodcastsRef.current.addEventListener('click', () => {
          document.location.href =`podcast://${userFeedUrl.replace('https://', '')}`;
        });

        // add event listner on click of the link for Google Podcasts
        googlePodcastsRef.current.addEventListener('click', () => {
          document.location.href =`googlepodcasts://subscribe-by-rss-feed?feed=${btoa(userFeedUrl)}`;
        });

        // add event listner on click of the link for Overcast
        overcastRef.current.addEventListener('click', () => {
          document.location.href =`overcast://x-callback-url/add?url=${encodeURIComponent(userFeedUrl)}`;
        });

        // add event listner on click of the link for Pocket Casts
        pocketCastsRef.current.addEventListener('click', () => {
            alert("Episodes may take a few hours to show up. For a faster experience, use Apple Podcasts, Overcast, Google Podcasts, or another podcast app.")

          document.location.href =`pktc://subscribe/${userFeedUrl.replace('https://', '')}`;
        });

        // add event listner on click of the link for Downcast
        downcastRef.current.addEventListener('click', () => {
          document.location.href =`downcast://${userFeedUrl.replace('https://', '')}`;
        });

        // add event listner on click of the link for Castro
        castroRef.current.addEventListener('click', () => {
          // copy to clipboard
          navigator.clipboard.writeText(userFeedUrl);
          document.location.href =`castros://subscribe/${userFeedUrl.replace('https://', '')}`;
        })

        // add event listner on click of the link for Radio Public
        radioPublicRef.current.addEventListener('click', () => {
          document.location.href =`https://radiopublic.com/${encodeURIComponent(userFeedUrl)}`;
        });

      }catch(err){
        console.log(err);
      }

    }
  }, [userFeedUrl]);

  useEffect(() => {
    if (app) {
      // NOTE: unsure which way is better, so firing two events
      mixpanel.track(`Select ${app} (Onboarding)`);
      mixpanel.track(`Select Podcast App (Onboarding)`, { 'Podcast App': app });
    }
  }, [app]);
  QRCode.toDataURL(`${FRONTEND_ENDPOINT}/setupnew/ios?feed_url=${userFeedUrl}`)
    .then((url) => {
      setQrCode(url);
    })
    .catch((err) => {
      console.error(err);
    });

  const renderCta = () => {
    return (
      <div
        className="cta-div"
        style={{ position: 'static', marginTop: '20px' }}
      >
        <Link
          to="/add"
          onClick={(e) => {
            mixpanel.track('Successful Podcast Subscription (Onboarding)');
          }}
        >
          <button className="cta-button">I subscribed successfully</button>
        </Link>
        <a
          href="https://www.tidio.com/talk/gzpx0hksecqrxjt9t2vix680h5aiodfj"
          target="_blank"
          className="sub-cta-link"
          onClick={(e) => {
            mixpanel.track('Unsuccessful Podcast Subscription (Onboarding)');
          }}
        >
          I have issues subscribing
        </a>
      </div>
    );
  };

  return (
    <div className="center">
      {isMobile ? (
        <>
          {app ? (
            <div>
              <h1 className="headline">Instructions for {app} </h1>
            </div>
          ) : (
            <div>
              <h1 className="headline">Choose Your Podcast App </h1>
              <h2 className="subheadline">
                Finish subscribing to your private podcast channel in the app
              </h2>
            </div>
          )}

          <IosInstructions app={app} feedUrl={userFeedUrl} />

          <div className="podcast-app-container">
            <a
              ref={applePodcastsRef}
              value="Apple-Podcasts"
              className="transparent-button mobile"
              // onClick={(e) => setApp('Apple Podcasts')}
            >
              Apple Podcasts
            </a>
            <a
              className="transparent-button mobile"
              onClick={(e) => setApp('Spotify')}
            >
              <img src={spotify} />
              Spotify
            </a>
            <a
              ref={overcastRef}
              className="transparent-button mobile"
              // href={encodeURI(`overcast://x-callback-url/add?url=${userFeedUrl}`)}
              // target="_blank"
            >
              Overcast
            </a>
            <a
              className="transparent-button mobile"
              ref={pocketCastsRef}
              // href={`pktc://subscribe/${userFeedUrl}`}
              // onClick={(e) =>
              //   alert(
              //     "Note: New articles may take a few hours to show up. For a faster experience, use Apple Podcasts."
              //   )
              // }
              // target="_blank"
            >
              Pocket Casts
            </a>
            <a
              ref={googlePodcastsRef}
              className="transparent-button mobile"
              // onClick={(e) => setApp('Google Podcasts')}
            >
              Google Podcasts
            </a>

            <a 
              ref={castroRef}
              className="transparent-button mobile"
              // onClick={(e) => setApp('Castro')}
            >
              Castro
            </a>
            <a
              ref={radioPublicRef}
              className='transparent-button mobile'
              >
              Radio Public
            </a>
            <a
              ref={downcastRef}
              className="transparent-button mobile"
              // onClick={(e) => setApp('Downcast')}
            >
              Downcast
            </a>
            <a
              className="transparent-button mobile"
              onClick={(e) => setApp('Breaker')}
            >
              Breaker
            </a>
            <a
              className="transparent-button mobile"
              onClick={(e) => setApp('Airr')}
            >
              Airr
            </a>
            {/* <a
              className="transparent-button mobile"
              onClick={(e) => {
                alert(
                  'New articles may take up to a few hours to show up. For a faster experience, try another app.'
                );
                setApp('Pocket Casts');
              }}
            >
              Pocket Casts
            </a> */}
            <a
              className="transparent-button mobile"
              onClick={(e) => {
                alert(
                  'New articles may take up to a few hours to show up. For a faster experience, try another app.'
                );
                setApp('Castbox');
              }}
            >
              Castbox
            </a>
            <a
              className="transparent-button mobile"
              onClick={(e) => setApp('Podbean')}
            >
              Podbean
            </a>
            <a
              className="transparent-button mobile"
              onClick={(e) => setApp('The Podcast App')}
            >
              The Podcast App
            </a>
            <a
              className="transparent-button mobile"
              onClick={(e) => setApp('Other Apps')}
            >
              Other Apps
            </a>
          </div>

          {isOnboarding !== 'false' && renderCta()}
        </>
      ) : (
        <>
          <h1 className="headline">Scan QR Code </h1>
          <h2
            style={{
              display: !showInstructions ? 'block' : 'none',
            }}
            onClick={(e) => {
              setShowInstructions(true);
              mixpanel.track('Click How to Scan (Onboarding)');
            }}
            className="subheadline clickable"
          >
            How to scan?
          </h2>

          <div
            style={{
              display: showInstructions ? 'block' : 'none',
            }}
          >
            <div>1. Open the default Camera app. </div>
            <div>2. Face the QR code for 3 seconds.</div>
            <div>3. Click the popup at the top. </div>
          </div>
          <img
            src={qrCode}
            alt="your qr code"
            width="250"
            height="auto"
            style={{ margin: '30px' }}
          ></img>
          {isOnboarding !== 'false' && renderCta()}
        </>
      )}
    </div>
  );
});

export default Ios;
